// The Camera panel's registration (docs/features/camera-presentation.md): the window `camera` (one per Mac), the
// Mac's ⋯ › Camera…, and the wire kind `presentation` (get · set → state; the panel reads link.presentation).
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'
import { registerWire } from '../../core/wire.js'

registerWindow('camera', { module: () => import('./camera.js'), css: 'windows/camera/camera.css', key: (a, key) => 'camera-' + (key || 'mac'), title: () => 'Camera', place: ['home', 'trailing'] })
registerHomeItem({ id: 'camera', label: 'Camera…', symbol: 'lucide:video', needs: 'paired', section: 'mac', order: 10 })
registerWire('presentation', (link, payload, m) => { if (m?.what === 'state') link.presentation = m })
